var DestinationColumn = /** @class */ (function () {
    function DestinationColumn(_a) {
        var id = _a.id, key = _a.key, columnName = _a.columnName;
        this.id = id;
        this.key = key;
        this.columnName = columnName;
    }
    DestinationColumn.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, key = _a.key, columnName = _a.columnName;
        if (typeof id !== 'string')
            throw new Error('id must be a string');
        if (typeof key !== 'string')
            throw new Error('key must be a string');
        if (columnName && typeof columnName !== 'string')
            throw new Error('columnName must be a string');
        return new DestinationColumn({
            id: id,
            key: key,
            columnName: columnName,
        });
    };
    return DestinationColumn;
}());
export default DestinationColumn;
